export default __webpack_public_path__ + "static/media/Prophecy_En.d1ab4bd7.webp";